import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { PartsCompleteButton } from '@app/react/uikit/arrow_parts/PartsCompleteButton';
import type { PartsProduct } from '@app/react/const/type';
import type { AppState } from '@app/react/reducer';
import { isSelectedAdjustProduct } from '@app/react/common/isSelectedAdjustProduct';
import { useHandleClick } from './operator';

const selectAl = (state: AppState): PartsProduct | null => state.customize.arrowlength;
const selectAlAdjust = (state: AppState): boolean | null => state.customize.arrowlengthAdjust;

interface YashakuCompleteButtonContainerProps {
    even?: boolean;
}
export const YashakuCompleteButtonContainer: FC<YashakuCompleteButtonContainerProps> = ({
    even,
}) => {
    const adjust = useSelector(selectAlAdjust);
    const al = useSelector(selectAl);

    const onClick = useHandleClick('yashaku');
    const status = isSelectedAdjustProduct(adjust, al);

    return (
        <PartsCompleteButton
            title="矢尺"
            title2="(矢の長さ)"
            status={status}
            required
            onClick={onClick}
            even={even}
        />
    );
};
